// @flow
import type { StateType } from '../../reducers';
import type { SignUpCheckOrderConsistencyStateType } from './reducer';

export const signUpCheckOrderConsistencyOrderStatusSelector = (
  state: StateType
): SignUpCheckOrderConsistencyStateType => state.signUp.checkOrderConsistency.isOrderOk;
